import React, { useContext } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import styles from "./Checkbox.scss";
import { ThemeContext } from "../Theme";

const CheckboxWrapper = ({
  children,
  disabled,
  checkboxId,
  customClass,
  ...restProps
}) => {
  const context = useContext(ThemeContext);

  return (
    <label
      className={cx(
        styles.checkbox,
        {
          [styles[context]]: context,
          "is-disabled": disabled,
        },
        customClass
      )}
      htmlFor={checkboxId}
      {...restProps}
    >
      {children}
    </label>
  );
};

CheckboxWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  disabled: PropTypes.bool,
  checkboxId: PropTypes.string.isRequired,
  customClass: PropTypes.string,
};

CheckboxWrapper.defaultProps = {
  disabled: false,
  customClass: undefined,
};

CheckboxWrapper.displayName = "Checkbox.Wrapper";

export default CheckboxWrapper;
